module.exports = __webpack_public_path__ + "static/16-ddcc718ccd78a9a5de6e0f1b400ff33e.jpg";